(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bc-product-bundle-content"] && !Shopify.designMode) return;
  try {
    if (!window.BCProductBundleInit) {
    window.BCProductBundleInit = true;

    function formatBundleMoney(cents, currency) {
      var value = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'EUR' }).format(value);
      } catch (e) {
        return 'EUR ' + value.toFixed(2);
      }
    }

    function findBundleVariant(section, plug) {
      var fallback = section.querySelector('[data-bc-bundle-variant]');
      var exact = null;
      if (plug) {
        section.querySelectorAll('[data-bc-bundle-variant]').forEach(function(node) {
          if (!exact && node.getAttribute('data-plug') === plug) exact = node;
        });
      }
      return exact || fallback;
    }

    function updateBundlePlugButtons(section, plug) {
      section.querySelectorAll('[data-bc-bundle-plug]').forEach(function(button) {
        var selected = button.getAttribute('data-bc-bundle-plug') === plug;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    function syncMainProductPlug(plug) {
      if (!plug) return;
      document.querySelectorAll('[data-bc-product-system]').forEach(function(section) {
        var plugSelector = section.querySelector('[data-bc-plug-selector]');
        var button = section.querySelector('[data-bc-plug-button][data-plug="' + plug + '"]');
        if (!button || plugSelector && plugSelector.hasAttribute('hidden')) return;
        if (section.getAttribute('data-selected-plug') === plug) return;
        button.click();
      });
    }

    function updateBundleSummaryRows(section, priceCents, savingsCents, currency) {
      var rows = Array.prototype.slice.call(section.querySelectorAll('[data-bc-bundle-summary-row]'));
      if (!rows.length) return;

      var rowSubtotal = rows.reduce(function(total, row) {
        return total + Number(row.getAttribute('data-regular-cents') || 0);
      }, 0);
      var allocatedSavings = 0;

      rows.forEach(function(row, index) {
        var regularCents = Number(row.getAttribute('data-regular-cents') || 0);
        var itemSavings = 0;

        if (savingsCents > 0 && rowSubtotal > 0 && regularCents > 0) {
          if (index === rows.length - 1) {
            itemSavings = savingsCents - allocatedSavings;
          } else {
            itemSavings = Math.floor((savingsCents * regularCents) / rowSubtotal);
            allocatedSavings += itemSavings;
          }
        }

        itemSavings = Math.max(0, Math.min(itemSavings, regularCents));

        var regular = row.querySelector('[data-bc-bundle-summary-regular]');
        var price = row.querySelector('[data-bc-bundle-summary-price]');
        var saving = row.querySelector('[data-bc-bundle-summary-saving]');

        if (regular) {
          regular.textContent = formatBundleMoney(regularCents, currency);
          regular.toggleAttribute('hidden', itemSavings <= 0);
        }
        if (price) price.textContent = formatBundleMoney(regularCents - itemSavings, currency);
        if (saving) {
          saving.textContent = 'Save ' + formatBundleMoney(itemSavings, currency);
          saving.toggleAttribute('hidden', itemSavings <= 0);
        }
      });
    }

    function setBundleVariant(section, node) {
      if (!node) return;

      var variantId = node.getAttribute('data-variant-id');
      var variantTitle = node.getAttribute('data-variant-title') || '';
      var priceCents = Number(node.getAttribute('data-price-cents') || 0);
      var compareCents = Number(node.getAttribute('data-compare-cents') || 0);
      var plug = node.getAttribute('data-plug') || '';
      var subtotalCents = Number(section.getAttribute('data-component-subtotal') || 0);
      var available = node.getAttribute('data-available') === 'true';
      var currency = section.getAttribute('data-currency') || 'EUR';
      var savingsCents = Math.max(0, Math.max(compareCents || subtotalCents, subtotalCents) - priceCents);

      var input = section.querySelector('[data-bc-bundle-input]');
      var total = section.querySelector('[data-bc-bundle-total]');
      var ctaPrice = section.querySelector('[data-bc-bundle-cta-price]');
      var savingRow = section.querySelector('[data-bc-bundle-saving-row]');
      var saving = section.querySelector('[data-bc-bundle-saving]');
      var submit = section.querySelector('[data-bc-bundle-submit]');
      var currentTitle = section.querySelector('[data-bc-bundle-current-title]');
      var currentSummaryTitle = section.querySelector('[data-bc-bundle-current-summary-title]');
      var compareInput = section.querySelector('[data-bc-bundle-compare-input]');

      if (input) input.value = variantId;
      if (compareInput) compareInput.value = Math.max(compareCents || subtotalCents, subtotalCents);
      if (currentTitle && variantTitle) currentTitle.textContent = variantTitle;
      if (currentSummaryTitle && variantTitle) currentSummaryTitle.textContent = variantTitle;
      if (total) total.textContent = formatBundleMoney(priceCents, currency);
      if (ctaPrice) ctaPrice.textContent = formatBundleMoney(priceCents, currency);
      if (savingRow) savingRow.toggleAttribute('hidden', savingsCents <= 0);
      if (saving) saving.textContent = '-' + formatBundleMoney(savingsCents, currency);
      if (submit) submit.disabled = !available;
      updateBundlePlugButtons(section, plug);
      updateBundleSummaryRows(section, priceCents, savingsCents, currency);
    }

    function initBundle(section) {
      if (section.getAttribute('data-bc-product-bundle-ready') === 'true') return;
      section.setAttribute('data-bc-product-bundle-ready', 'true');
      section.querySelectorAll('[data-bc-bundle-plug]').forEach(function(button) {
        button.addEventListener('click', function() {
          var plug = button.getAttribute('data-bc-bundle-plug') || '';
          setBundleVariant(section, findBundleVariant(section, plug));
          syncMainProductPlug(plug);
        });
      });
      setBundleVariant(section, findBundleVariant(section));
    }

    function initBundles() {
      document.querySelectorAll('[data-bc-product-bundle]').forEach(initBundle);
    }

    document.addEventListener('bc-product:variant-change', function(event) {
      var plug = event.detail && event.detail.plug;
      if (!plug) return;
      document.querySelectorAll('[data-bc-product-bundle]').forEach(function(section) {
        setBundleVariant(section, findBundleVariant(section, plug));
      });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBundles);
    } else {
      initBundles();
    }
  }
  } catch(e) { console.error(e); }
})();

})();
